<template>
	<div class="wrapper">
		<breadcrumbs></breadcrumbs>
		<div class="wrappers">
			<div class="mn">
				<div class="pl">
					<div class="zhanzhuai_viewthreadtop">
						<div class="table">
							<div class="plc" style="position: relative;">
								<div class="zhanzhuai_view_h1 cl">
									<h1 class="ts">{{info.title}}</h1>
								</div>
								<div class="zhanzhuai_authi authi">
									<span class="a">{{info.nickname}}</span>
									<span class="mrn">发表于 {{info.createTime}}</span>
									<span class="ftn_comment y">{{info.show}}</span>
									<span class="ftn_readNum mrw">{{info.pinglunnum}}</span>
								</div>
								
								<img v-if="info.jinghua==1" src="../../../assets/jinghua01.png" style="position: absolute;width: 30px;top: 0px;right: 0px;" alt="">
							</div>
						</div>	
						
					</div>
					<div style="width: 100%;height: 1px;background: #ececec;"></div>
					<div class="zhanzhuai_viewthreadtop">
						<div class="content" style="padding-top: 10px;padding-bottom: 20px;">
							<mavonEditor :value="info.content"  style="box-shadow: none;"
										:subfield="false"
										defaultOpen="preview"
										:toolbarsFlag="false"
							:editable="false"
							:scrollStyle="true"
										/>
						</div>
						<!--操作-->
						<div class="plc" style="padding: 0 25px;">
							<div class="po hin">
								<div class="pob cl hahas">
									<div class="fastre" @click="huifuclick">回复</div>
									<div class="fastres" @click="handlecreate(2)" v-if="info.isedit==true">编辑</div>
									<div class="fastres ssss" @click="user_save_tiezi(1)" v-if="info.jinghua==2">设为精华帖</div>
									<div class="fastres ssss" @click="user_save_tiezi(2)" v-if="info.jinghua==1">取消精华帖</div>
								</div>
							</div>
						</div>
						<!--操作-->
					</div>
				</div>
				<!--没有评论回显-->
				<div class="zz_js_empy box cl" style="margin-top: 20px;" v-if="info.pinglunnum==0">
					<div class="zz_empy_icon cl"></div>
					<p>没找到任何评论，期待你打破沉寂</p>
				</div>
				<!--没有评论回显-->
				<div class="zhanzhuai_viewtitle cl" v-if="info.pinglunnum>0">
					<div class="h4">共有（{{info.pinglunnum}}）条评论</div>
				</div>
				<div v-if="info.pinglunnum>0" class="zhanzhuai_replythread box zhanzhuai_replythread_close"  v-for="(item,i) in info.pinglunlist" :key="i">
					<div class="table_reply plhin">
						<div class="plc plct">
							<div class="pi">
								<div class="zhanzhuai_cleft_avatar">
									<img :src="item.headimgurl" alt="">
								</div>
								<div class="pti">
									<div class="authi">
										{{item.nickname}}
									</div>
									<div class="autis">发表于 {{item.createTime}}</div>
								</div>
							</div>
							<!--回复别人的帖子-->
							<div class="quote" v-if="item.huifuid">
								<div class="blockquote">
									<div class="blockquote01">{{item.pidnickname}} 发表于 {{item.pidcreateTime}}</div>
									<div class="blockquote02">{{item.pidcontent}}</div>
								</div>
							</div>
							<!--回复别人的帖子-->
							<div class="pct">
								<div class="t_fsz">{{item.content}}</div>
							</div>
							<div class="plc plcb" style="overflow: visible;width: 100%;">
								<div class="po hin">
									<div class="pob cl">
											<div class="aaa" @click='huifus(item)'>
												回复
											</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--右侧部分-->
			<div class="ri">
				<div class="zhanzhuai_pposts_btn cl" @click="handlecreate(1,'')">发布新帖</div>
				<div class="viewthread_author box cl">
					<div class="zhanzhuai_viewthread_user_c">
						<div class="zhanzhuai_viewthread_user cl" style="display: flex;align-items: center;">
							<div class="viewthread_author_avatar z">
								<img :src="info.headimgurl" alt="">
							</div>
							<div class="viewthread_author_info cl">
								<div class="phone">{{info.nickname}}</div>
							<!-- 	<div class="p">管理员</div> -->
							</div>
						</div>
						<div class="zz_lz_author_mun cl">
							<div class="li" @click="taboke(info.uid)" style="cursor: pointer;">
								<div class="number">{{info.bokenum}}</div>
								<div class="inst">博客</div>
							</div>
							<div class="li">
								<div class="number">{{info.tiezinum}}</div>
								<div class="inst">帖子</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						Ta的帖子
					</div>
					<div class="yueduo">
						<div class="yueduos"  v-for="(item,i) in info.tiezilist" @click="details(item)" :key="i">
							<i></i>
							<div class="yueduos01">
								<div class="zz_recnews_title">{{item.title}}</div>
								<div class="zz_recnews_time">{{item.createTime}}</div>
							</div>
						</div>
					</div>
				</div>
				
<!-- 				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title" style="margin-bottom: 0px;">
						24小时热文
					</div>
					<div class="rewenlist" v-for="(item,i) in 6" :key="i">
						<div class="zz_express_pic">
							<img src="../../../assets/index/head01.png" alt="">
						</div>
						<div class="zz_express_txt">
							<div class="hs">
								<div class="hss">
									dsadsadsadsadsadsadsadsa
								</div>
							</div>
							<span>2022-08-08</span>
						</div>
					</div>
				</div> -->
				
			</div>
		</div>
		
		<!--发布新帖-->
		<save ref="savedata" @succ="succcreate"></save>
		<!--发布新帖-->
		<!--评论-->
		<pinglun ref="pinglundata" @pingsucc="tiezi_detail()"></pinglun>
		<!--评论-->
	</div>
</template>

<script>
	import { tiezi_detail,user_save_tiezi } from "@/api/boke"
	import save from "./components/save.vue"
	import { getToken } from '@/utils/auth'
	import pinglun from "./components/pinglun.vue"
	export default{
		components:{
			save,pinglun
		},
		data(){
			return{
				id:'',
				info:{},
				loading:false,
			}
		},
		mounted(){
			if(this.$route.query.id){
				document.title = "帖子详情";
				this.id = this.$route.query.id
				this.tiezi_detail();
			}else{
				this.$message.error("该帖子不存在");
			}
			
		},
		methods:{
			succcreate(id){
				this.id = id
				this.tiezi_detail();
			},
			handlecreate(type){
				//需要先判断一下是否登录
				if(getToken()){
					if(type==2){
						if(this.info.isedit==true){
							this.$refs.savedata.handlecreate(type,this.info);
						}else{
							this.$message.error("无权限操作");
						}
					}else{
						this.$refs.savedata.handlecreate(type,this.info);
					}
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			huifuclick(){
				if(getToken()){
					this.$refs.pinglundata.handlecreate(this.info.title,this.info.id);
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			huifus(item){
				if(getToken()){
					this.$refs.pinglundata.handlecreates(item.content,item.proid,item.id);
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			details(item){
				document.title = item.title
				this.id = item.id
				this.tiezi_detail()
			},
			tiezi_detail(){
				this.loading = true
				tiezi_detail({
					id:this.id
				}).then(res=>{
					this.loading = false
					console.log("帖子详情",res.data);
					this.info = res.data
					document.title = res.data.title
				}).catch(()=>{
					this.loading = false
				})
			},
			taboke(uid){
				this.$router.push({
					path:"/taboke",
					query:{
						uid:uid
					}
				})
			},
			user_save_tiezi(jinghua){
				let data = this.info;
				const loading = this.$loading({
				    lock: true,
				    text: '设置中',
				    spinner: 'el-icon-loading',
				    background: 'rgba(0, 0, 0, 0.7)'
				  });
				  user_save_tiezi({
					  id:data.id,
					  zhuantiid:data.zhuantiid,
					  title:data.title,
					  content:data.content,
					  jinghua:jinghua
				  }).then(()=>{
					  loading.close();
					  this.$message.success("成功");
					  this.tiezi_detail();
				  }).catch(()=>{
					  loading.close();
					  this.tiezi_detail();
				  })
			},
		},
	}
</script>

<style lang="scss" scoped>
	.zz_js_empy{
		margin-bottom: 15px;
		    padding: 30px;
		    border-radius: 4px;
		    text-align: center;
		.zz_empy_icon{
			display: block;
			    min-height: 180px;
			background: url("../../../assets/zz_empy_icon.png") no-repeat center 23px;
			background-size: 190px auto;
			box-sizing: border-box;
			    text-align: center;
		}
		p{
			    margin-top: 28px;
			    margin-bottom: 8px;
			    font-size: 14px;
			    color: #969696;
			    text-align: center;
		}
	}
	.hahas{
		display: flex;
		align-items: center;
		font-size: 14px;
		cursor: pointer;
		padding-top: 40px;
	}
	.fastre{
		padding: 5px 10px 5px 25px;
		background: url("../../../assets/fastreply.gif") no-repeat 0 50%;
	}
	.fastres{
		padding: 5px 10px 5px 25px;
		margin-left: 20px;
		background: url("../../../assets/edit.gif") no-repeat 0 50%;
	}
	.ssss{
		background: none!important;
	}
	.quote{
		    margin: 10px 0;
		    padding: 10px 10px 10px 65px;
		background: #f9f9f9 url("../../../assets/icon_quote_s.gif") no-repeat 20px 6px;
		color: #666;
		overflow: hidden;
	.blockquote{
		    display: inline-block;
		    margin: 0;
		    padding: 0 65px 5px 0;
		    background: url("../../../assets/icon_quote_e.gif") no-repeat 100% 100%;
		    line-height: 1.6;
		    zoom: 1;
			.blockquote02{
				color: #333;
				font-size: 14px;
				margin-top: 5px;
				white-space: pre-wrap;
			}
		.blockquote01{
			text-decoration: underline;
			color: #999;
			font-size: 10px;
			cursor: pointer;
    
		}
		.blockquote01:hover{
			color: #FFA07A;
		}
	}
	}
	.rewenlist:nth-child(1){
		padding: 0px;
	}
	.rewenlist{
		height: 65px;
		padding: 20px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
		.zz_express_txt{
			cursor: pointer;
			    height: 65px;
			    overflow: hidden;
				span{
					font-size: 12px;
					    color: #8590a6;
				}
	
				.hs{
					margin-bottom: 8px;
					    max-height: 40px;
					    text-overflow: ellipsis;
					    overflow: hidden;
					    -webkit-line-clamp: 2;
					.hss{
						line-height: 20px;
						    font-size: 14px;
						    color: #18191a;
						    font-weight: 400;
						    word-break: break-word;
					}
					.hss:hover{
						color: #FFA07A;
					}
				}
		}
		.zz_express_pic{
			position: relative;
			    float: left;
			    width: 100px;
			    height: 65px;
			    margin-right: 12px;
			    overflow: hidden;
				img{
					width: 100px;
					    height: 65px;
					    vertical-align: top
				}
			span{
				position: absolute;
				    top: 0;
				    left: 0;
				    height: 20px;
				    padding: 0 10px;
				    color: #fff;
				    font-size: 12px;
				    line-height: 20px;
				    opacity: .85;
				    background-color: #313B3D;
				    border-radius: 2px 0 0;
			}
		}
	}
	.yueduo{
		border-left: 1px solid #EEEEEE;
		.yueduos{
			position: relative;
	        padding: 6px 0 6px 15px;
			cursor: pointer;
			.yueduos01{
				line-height: 24px;
				color: #999;
				.zz_recnews_title{
					font-size: 14px;
					color: #333;
					overflow: hidden;
				}
				.zz_recnews_title:hover{
					color: #FFA07A;
				}
				.zz_recnews_time{
					margin-bottom: 10px;
					font-size: 14px;
					font-style: inherit;
					font-family: Georgia;
				}
			}
			i{
			    width: 5px;
			    height: 5px;
			    background: #fff;
			    border-width: 1px;
			    border-color: #aaa;
			    border-style: solid;
			    border-radius: 100%;
			    position: absolute;
			    z-index: 1;
			    left: -4px;
			    top: 15px;	
			}
		}
		.yueduos:hover{
			i{
				background: #FFA07A;
				border-color: #FFA07A;
			}
		}
	}
	.zz_lz_author_mun{
		margin: 25px 0 20px;
		    overflow: hidden;
			display: flex;
			align-items: center;
			.li:nth-child(2){
				border-right: none;
			}
		.li{
		    width: 50%;
		    border-right: 1px solid rgba(230,232,235,.98);
		    text-align: center;	
			.number{
				line-height: 17px;
				    font-size: 16px;
				    color: #18191a;
				    font-weight: 500;
			}
			.inst{
				    height: 17px;
				    line-height: 17px;
				    margin-top: 3px;
				    font-size: 12px;
				    color: #aaaeb3;
				}
		}
	}
	.viewthread_author{
		position: relative;
		    margin-bottom: 15px;
			.viewthread_author_info{
				position: relative;
				    overflow: hidden;
					display: flex;
					justify-content: center;
					flex-direction: column;
					cursor: pointer;
				.phone{
					font-size: 16px;
					    color: #2d2d2d;
					    font-weight: 500;
					    overflow: hidden;
					    // text-overflow: ellipsis;
					    // white-space: nowrap;
						cursor: pointer;
				}
				.phone:hover{
					color: #FFA07A;
				}
				.p{
					font-size: 12px;
					color: #969696;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					margin-top: 5px;
				}
			}
		.zhanzhuai_viewthread_user_c{
			.viewthread_author_avatar{
				position: relative;
				    width: 45px;
				    height: 45px;
				    margin-right: 12px;
				img{
					width: 45px;
					height: 45px;
					border-radius: 50%;
					background: #f5f6f7;
					transition: all .5s;
				}
			}
			padding: 25px 25px 10px;
		}
	}
	.zhanzhuai_pposts_btn{
		width: 100%;
		    height: 50px;
		    line-height: 50px;
		    margin-bottom: 15px;
		    text-align: center;
		    border-radius: 4px;
		    background: #fc7247;
			color: #fff;
			font-size: 15px;
			text-align: center;
			cursor: pointer;
	}
	.zhanzhuai_replythread{
		    margin-bottom: 15px;
		    background: #fff;
		    border-radius: 4px;
		    box-sizing: border-box;
		    overflow: hidden;
			.aaa{
				cursor: pointer;
				padding: 5px 10px 5px 25px;
				color: #333;
				font-size: 12px;
				background: url("../../../assets/fastreply.gif") no-repeat 0 50%;
			}
			.po{
				    padding-top: 15px;
				    border-top: 1px dashed #f0f0f0;
			}
			.pob{
				line-height: 36px;
			}
			.pct{
				margin-top: 20px;
				    padding: 15px 0 0;
				    border-top: 1px solid #f0f0f0;
				.t_fsz{
					min-height: 50px;
					white-space: pre-wrap;
				}
			}
			.pti{
				display: flex;
			    align-items: center;
			}
			.authi{
				font-size: 14px;
				color: #333;
				margin-right: 5px;
			}
			.authi:hover{
				color: #FFA07A;
			}
			.autis{
				font-size: 12px;
				color: #999;
			}
			.pi{
				height: 30px;
				cursor: pointer;
				    line-height: 30px;
				    padding: 0px!important;
				    margin: 0;
				    border-bottom: 0px;
			   .zhanzhuai_cleft_avatar{
				   float: left;
				       width: 30px;
				       height: 30px;
				       margin-right: 12px;
				       display: inline-block;
				       vertical-align: middle;
				       zoom: 1;
					img{
						    width: 100%;
						    height: 100%;
						    border-radius: 50px;
					}
			   }
			}
		.table_reply{
			    table-layout: fixed;
			    width: 100%;
			.plct{
				    padding: 20px 25px 15px;
			}
			.plc{
				background: transparent;
			}
		}
	}
	.zhanzhuai_viewtitle{
		position: relative;
		    height: 60px;
			margin-top: 15px;
		    margin-bottom: 5px;
		    background: #fff;
		border-radius: 4px;
		    border: 1px solid #f5f6f7;
			transition: all .6s ease;
		.h4{
			    float: left;
			    width: 500px;
			    height: 100%;
				display: flex;
				align-items: center;
			    margin-left: 25px;
			    font-size: 18px;
			    color: #333;
			    font-weight: 700;
			    overflow: hidden;
		}
	}
	.content{
		width: 100%;
	}
	.pl{
		.zhanzhuai_authi{
			color: #a8afbb;
			font-size: 12px;
			display: flex;
			align-items: center;
			.ftn_readNum,.ftn_comment{
				margin-right: 0;
				    background-position: 0 -17px;
					height: 18px;
					    line-height: 18px;
			    padding-left: 24px;
				color: #a8afbb;
				background: url("../../../assets/postsprite.png") no-repeat 0 -1px;
			}
			.ftn_readNum{
				margin-left: 20px;
				background: url("../../../assets/postsprite.png") no-repeat 0 -18px;
			}
			.mrw {
			    margin-right: 20px !important;
			}
			.y{
				margin-left: auto;
			}
			.a{
				color: #a8afbb;
				margin-right: 7px!important;
				cursor: pointer;
			}
			.mrn{
				color: #a8afbb;
				margin-right: 7px!important;
			}
		}
		.zhanzhuai_viewthreadtop{
			.table{
				width: 100%;
				.plc{
					padding: 0 0 15px;
					color: #333;
					overflow: hidden;
					.zhanzhuai_view_h1{
						position: relative;
						    margin-bottom: 15px;
						    padding-right: 75px;
						.ts{
							// line-height: 36px;
							font-size: 22px;
							color: #333;
							font-weight: 700;
						}
					}
				}
			}
			padding: 10px 25px 10px;
			    background: #fff;
			border-radius: 4px 4px 0 0;
			    border: 0;
			transition: all .6s ease;
			    overflow: hidden;
				transition: all .6s ease;
				    overflow: hidden;
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
			display: flex;
			.mn{
				width: 860px;
				margin-bottom: 10px;
			}
			.ri{
				width: 325px;
				margin-left: auto;
				margin-bottom: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/luntan/detail.vue